import { render, staticRenderFns } from "./Requisitioners.vue?vue&type=template&id=0935033c&lang=pug&"
import script from "./Requisitioners.vue?vue&type=script&lang=js&"
export * from "./Requisitioners.vue?vue&type=script&lang=js&"
import style0 from "./Requisitioners.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports